import {Injectable, OnInit} from '@angular/core';
import { environment } from '../environments/environment';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Router} from "@angular/router";
import {Subject} from "rxjs/Subject";
import * as _ from "lodash";

@Injectable()
export class AuthService {

  session: any = {
    isLoggedIn: false,
    user: {}
  };

  loading: boolean = false;
  loadingChange: Subject<boolean> = new Subject<boolean>();

  possibleConnection;
  possibleConnectionChange: Subject<any> = new Subject<any>();

  connectedAs;
  connectedAsChange: Subject<number> = new Subject<number>();

  redirectUrl;

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
    if (this.router.url != '/cgu') {
      this.getConnection();
    }
  }

  getConnection() {
    this.possibleConnection = [];
    this.connectedAs = {};
    this.loading = true;
    this.loadingChange.next(this.loading);
    this.http.get(environment.API_PATH + '/user/me', {withCredentials: true})
	  .subscribe(
      data => {
        this.loading = false;
        this.loadingChange.next(this.loading);
        this.session.isLoggedIn = true;
        this.session.user = data;
        this.connectedAs = {
          id: this.session.user.account_id,
          name: data['firstname'] + ' ' + data['lastname'],
          admin: this.session.user.account_type === 'admin' ? true : false
        };

        this.possibleConnection = [this.connectedAs];
        if (this.session.user.account_type === 'admin') {
          this.loading = true;
          this.loadingChange.next(this.loading);
          this.http.get(environment.API_PATH + '/session/me', {withCredentials: true})
				  .subscribe(
            data => {
              this.loading = false;
              this.loadingChange.next(this.loading);
              if (data['connectedTabAs'])
                this.possibleConnection = _.concat(this.possibleConnection, data['connectedTabAs']);
              var exist = _.find(this.possibleConnection, function (conn) {
                return conn.id === data['connectedAs'];
              });
              if (exist)
                this.connectedAs = exist;
              this.possibleConnectionChange.next(this.possibleConnection);
              this.connectedAsChange.next(this.connectedAs);
              this.router.navigate(['administration', 'home']);
            },
            err => {
              this.loading = false;
              this.loadingChange.next(this.loading);
              this.session.isLoggedIn = false;
              this.session.user = {};
              this.router.navigate(['/connexion']);
            })
        }
        else {
          this.possibleConnectionChange.next(this.possibleConnection);
          this.connectedAsChange.next(this.connectedAs);
          this.router.navigate(['administration', 'home']);
        }

      },
      err => {
        this.loading = false;
        this.loadingChange.next(this.loading);
        this.session.isLoggedIn = false;
        this.session.user = {};
        this.router.navigate(['/connexion']);
      });
  }

  addConnection (connection) {
    if (this.session.user.account_type == 'admin') {
      this.http.post(environment.API_PATH + '/session/add', {connectedAs: {id: connection.id, name: connection.name, admin: connection.admin ? connection.admin : false}}, {withCredentials: true} )
      .subscribe(data => {
        this.getConnection();
      },
      err => {
        this.deleteSession();
      });
    }
  }

  getSession() {
    return this.session;
  }

  currentIsAdmin() {
    if (this.session.user.account_type == 'admin')
      return this.connectedAs.admin;
    else
      return false;
  }

  currentIsSuperAdmin() {
    if (this.session.user.account_type == 'admin' && this.session.user.superadmin)
      return true;
    else
      return false;
  }

  login(data) {
    this.session.isLoggedIn = true;
    this.session.user = data;
    this.connectedAs = {
      id: this.session.user.account_id,
      name: data['firstname'] + ' ' + data['lastname'],
      admin: this.session.user.account_type === 'admin' ? true : false
    };
    this.possibleConnection = [this.connectedAs];
    this.possibleConnectionChange.next(this.possibleConnection);
    this.connectedAsChange.next(this.connectedAs);
    this.router.navigate(['administration']);
  }

  deleteSession() {
    this.http.get(environment.API_PATH + '/logout', {withCredentials: true})
    .subscribe(res => {
      this.session.isLoggedIn = false;
      this.session.user = {}
      this.connectedAs = {};
      this.possibleConnection = [];
      this.router.navigate(['connexion']);
    });

  }

  logout() {
    if (this.session.user.account_type == 'admin') {
      if (this.currentIsAdmin()) {
        this.deleteSession();
      }
      else {
        this.http.delete(environment.API_PATH + '/session/delete/' + this.connectedAs.id, {withCredentials: true})
	      .subscribe(
          data => {
            this.getConnection();
          },
          err => {
            this.deleteSession();
          });
      }
    }
    else {
      this.deleteSession();
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts